import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Alert,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

class AddBillingItemModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      errors: {},
      itemName: '',
      itemDesc: '',
      itemQty: '',
      pricePerQty: '',
    };
    this.formIsValid = this.formIsValid.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show)
      this.setState({
        show: nextProps.show,
      });
  }

  createBillingItem = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    const { itemName, itemDesc, itemQty, pricePerQty } = this.state;
    const item = {
      logEntryId: this.props.entryId,
      itemName: itemName,
      itemDesc: itemDesc,
      itemQty: itemQty,
      pricePerQty: Number(pricePerQty).toFixed(2) * 100.0,
    };
    this.props.createBillingItem(item);
    this.setState({
      errors: {},
      itemName: '',
      itemDesc: '',
      itemQty: '',
      pricePerQty: '',
    });
    this.toggle();
  };

  formIsValid() {
    let errors = {};
    let isValid = true;
    const { itemName, itemQty, pricePerQty } = this.state;
    if (itemName === '') {
      isValid = false;
      errors.itemName = 'Please enter the item name.';
    }
    if (itemQty === null || itemQty === '') {
      isValid = false;
      errors.itemQty = 'Please enter the item quantity.';
    }
    if (pricePerQty === null || pricePerQty === '') {
      isValid = false;
      errors.pricePerQty = 'Price is required.';
    }
    this.setState({ errors: errors });
    return isValid;
  }

  toggle = () => {
    this.props.toggle();
  };

  render() {
    const { show, errors, itemName, itemDesc, itemQty, pricePerQty } =
      this.state;
    return (
      <div>
        <Modal isOpen={show} toggle={this.toggle}>
          <ModalHeader>Add Billing Item</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="itemName">Item Name</Label>
                <Input
                  type="text"
                  name="itemName"
                  id="itemName"
                  value={itemName}
                  onChange={(event) => {
                    this.setState({ itemName: event.target.value });
                  }}
                />
                {errors.itemName && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.itemName}
                  </Alert>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="itemDesc">Item Description</Label>
                <Input
                  type="textarea"
                  name="itemDesc"
                  id="itemDesc"
                  value={itemDesc}
                  onChange={(event) => {
                    this.setState({ itemDesc: event.target.value });
                  }}
                />
                {errors.itemDesc && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.itemDesc}
                  </Alert>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="itemQty">Quantity</Label>
                <Input
                  type="text"
                  name="itemQty"
                  id="itemQty"
                  value={itemQty}
                  onChange={(event) => {
                    this.setState({ itemQty: event.target.value });
                  }}
                />
                {errors.itemQty && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.itemQty}
                  </Alert>
                )}
              </FormGroup>
              <FormGroup>
                <Label for="pricePerQty">Price Per Qty</Label>
                <Input
                  type="text"
                  name="pricePerQty"
                  id="pricePerQty"
                  value={pricePerQty}
                  onChange={(event) => {
                    this.setState({ pricePerQty: event.target.value });
                  }}
                />
                {errors.pricePerQty && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.pricePerQty}
                  </Alert>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.createBillingItem}>
              Add Item
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default AddBillingItemModal;



// WEBPACK FOOTER //
// ./src/components/repair-log/AddBillingItemModal.js